import {combineReducers} from 'redux';

import cartoACSData from './cartoACSDataReducer'
import mapboxLayers from './mapboxLayersReducer'
import map from './mapReducer'
import ui from './uiReducer'

import {connectRouter} from 'connected-react-router'

export default (history) => combineReducers({
	router: connectRouter(history),
	
	cartoACSData,
	map,
	mapboxLayers,
	ui,
})

